import { type ReactElement } from "react";
import { GmailIcon } from "src/assets/icons/gmail";
import { OutlookIcon } from "src/assets/icons/outlook";

const EmailClientItem = ({
  icon,
  text,
  href,
}: {
  icon: ReactElement;
  text: string;
  href: string;
}) => (
  <a
    className="flex flex-row items-center gap-2 no-underline!"
    href={href}
    target="_blank"
    rel="noopener noreferrer"
  >
    <div className="flex h-6 w-6 items-center">{icon}</div>
    <div className="text-base font-normal text-[#111827]">{text}</div>
  </a>
);

export const SubmitSuccess = ({
  resendMagicLink,
}: {
  resendMagicLink: (target: React.MouseEvent<HTMLAnchorElement>) => void;
}) => (
  <div className="flex flex-col gap-[35px] border-t border-[#d2d5db] pt-10 text-xs text-[#4a5466] [&_a]:cursor-pointer [&_a]:underline">
    <div className="flex flex-row flex-wrap items-center justify-center gap-[25px] md:gap-14">
      <EmailClientItem
        href="https://mail.google.com/mail/u/0/#inbox"
        icon={<GmailIcon />}
        text="Open Gmail"
      />
      <EmailClientItem
        href="https://outlook.office.com/mail/inbox"
        icon={<OutlookIcon />}
        text="Open Outlook"
      />
    </div>
    <span className="flex flex-wrap justify-center gap-y-[5px] text-center text-sm font-medium text-[#4a5466] [&_a]:text-[#1453f5] [&_a]:no-underline">
      Didn&apos;t receive an email? Try checking your junk folder or{" "}
      <a onClick={resendMagicLink}>resend magic link</a>.
    </span>
  </div>
);
